import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/Hadeeb/Documents/js/react/reactive/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "devtool"
    }}>{`Devtool`}</h2>
    <p>{`Debug `}<inlineCode parentName="p">{`reactive`}</inlineCode>{` store with `}<a parentName="p" {...{
        "href": "http://extension.remotedev.io/"
      }}>{`Redux devtools extension`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { addReduxDevTool } from "@hadeeb/reactive/enhance";
const store = createStore();

addReduxDevTool(store, options);
`}</code></pre>
    <h2 {...{
      "id": "codesplitting"
    }}>{`CodeSplitting`}</h2>
    <p><inlineCode parentName="p">{`events`}</inlineCode>{` is a plain object. New event handlers can be added at any time`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import StaticModule from "...";

const events = {
  Initialize_Module({ state }, payload) {
    Object.assign(state, payload);
  }
};

Object.assign(events, StaticModule.events);

const initialState = StaticModule.initialState;

const store = createStore(events, initialState);

function addModule(lazyModule) {
  Object.assign(events, lazyModule.events);
  store.dispatch("Initialize_Module", lazyModule.initialState);
}
`}</code></pre>
    <h2 {...{
      "id": "customizing-store"
    }}>{`Customizing store`}</h2>
    <p><inlineCode parentName="p">{`store.$`}</inlineCode>{` can be used to override how the events are handled.`}</p>
    <p>{`Refer : `}<a parentName="p" {...{
        "href": "https://github.com/hadeeb/reactive/blob/96c9f93b8b4d0cea936bab361b1de8b96b0c07ce/enhance/src/devtool.ts#L44"
      }}>{`Redux devtool integration`}</a></p>
    <p><inlineCode parentName="p">{`store.$`}</inlineCode>{` : (store, event, payload):void`}</p>
    <p>{`eg: Event logger`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const store = createStore();

const originalHook = store.$;
store.$ = function(store, event, payload) {
  console.log({ event, payload });
  console.log("Before", store.getState());
  originalHook(store, event, payload);
  console.log("After", store.getState());
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      